// extracted by mini-css-extract-plugin
module.exports = {"bb-quote-image":"bb-quote-image__SWr8P"};